<template>
    <div class="footer-content">
        <div class="content">
            <div>
                <div class="title">
                    <img src="../assets/logo-footer.webp" alt="logo" />
                    MONEYBAY COMPANY LIMITED
                </div>
                <div class="item" v-for="item in list" :key="item.index">
                    <img :src="require('@/assets/footer-icon' + item.index + '.webp')" alt="">
                    {{ item.content }}
                </div>
            </div>
            <div>
                <div class="title">หน้า</div>
                <div class="item" @click="handleClick('/')">
                    หน้าแรก
                </div>
                <div class="item" @click="handleClick('/service')">
                    บริการ
                </div>
                <div class="item" @click="handleClick('/about')">
                    เกี่ยวกับเรา
                </div>
                <div class="item" @click="handleClick('/contact')">
                    ติดต่อเรา
                </div>
            </div>
        </div>
        <div class="bottom">
            Copyright 2025 © MONEYBAY COMPANY LIMITED All rights reserved
        </div>
    </div>
</template>
<script setup>
import { useRouter } from "vue-router";
const router = useRouter();
const handleClick = (path) => {
    router.push(path);
    window.scrollTo(0, 0);
};
const list = [
    {
        content: "+66 92 584 3514",
        index: 1,
    },
    {
        content: "77 หมู่ที่ 1 ตำบลท่าเสา อำเภอเมืองอุตรดิตถ์ จ.อุตรดิตถ์ 53000",
        index: 2,
    },
    {
        content: "sys@get-moneyservices.com",
        index: 3,
    }
];
</script>
<style lang="less" scoped>
.footer-content {
    width: 100%;
    height: 234px;
    background-color: #17263D;

    .content {
        display: flex;
        justify-content: space-between;
        padding: 23px 368px;
        box-sizing: border-box;

        .title {
            display: flex;
            align-items: center;
            font-weight: bold;
            font-size: 15px;
            color: #FFFFFF;
            line-height: 18px;
            margin-bottom: 26px;

            img {
                width: 43px;
                height: 43px;
                object-fit: contain;
                margin-right: 12px;
            }
        }

        .item {
            display: flex;
            align-items: center;
            font-weight: 500;
            font-size: 12px;
            color: rgba(255, 255, 255, 0.8);
            line-height: 12px;
            margin-bottom: 17px;

            img {
                width: 16px;
                object-fit: cover;
                margin-right: 8px;
            }
        }
    }

    .bottom {
        font-weight: 500;
        font-size: 12px;
        color: #F7F7F7;
        line-height: 15px;
        text-align: center;
    }
}
</style>